module.exports = __webpack_public_path__ + "static/media/BankWhite.518a621f.svg";